import { handleProgressive } from "./handleProgressive";
const hasValue = (v) => v !== null && v !== undefined && v !== "";

// 跨層讀取某 key（依 level 由小到大）
const readValueByKey = (EFFormData, key) => {
  for (const lvl of Object.keys(EFFormData || {}).sort((a, b) => +a - +b)) {
    const arr = EFFormData[lvl] || [];
    const hit = arr.find((o) => Object.hasOwn(o, key));
    if (hit) return hit[key];
  }
  return undefined;
};

export const resolveProgressiveOrder = (schema, EFFormData) => {
  const sw = schema?.progressiveOrderSwitch;

  // ---------- 沒有 progressiveOrderSwitch 就回傳空 ----------
  if (!sw) return [];

  // ---------- 直接用 handleProgressive 的結果 ----------
  const dynamicOrder = handleProgressive(schema, EFFormData);

  if (Array.isArray(dynamicOrder) && dynamicOrder.length > 0) {
    return dynamicOrder;
  }

  if (sw.by) {
    const byVal = readValueByKey(EFFormData, sw.by.key, sw.by.level);
    const key = hasValue(byVal) ? String(byVal) : undefined;
    const orderFromCase =
      (key && Array.isArray(sw.cases?.[key]) && sw.cases[key]) ||
      (Array.isArray(sw.cases?.default) && sw.cases.default) ||
      (Array.isArray(sw.cases?.["*"]) && sw.cases["*"]);
    if (orderFromCase) return orderFromCase;
  }

  // ---------- 最後回退 ----------
  return [];
};

export const buildPrefixByField = (schema, EFFormData, field, EAFormData) => {
  const dynamicCat = EAFormData?.categoryISO64;
  const cat = hasValue(dynamicCat) ? dynamicCat : schema?.cat ?? "";
  const mode = schema?.mode ?? "";
  const order = resolveProgressiveOrder(schema, EFFormData, field);
  console.log(order);
  const maxSegs = Math.max(1, Number(field?.combineKey ?? 1)); // 至少 1（只含 cat）

  // 起算點：欄位可覆寫 schema 預設
  const endIdx = order.indexOf(field.key); // 自己的位置（不含自己）

  // 取從 startBehind 之後 → 自己之前 的鍵作為候補
  const segKeys = order.slice(0, endIdx >= 0 ? endIdx : order.length);

  const segs = [];
  if (hasValue(cat)) segs.push(String(cat));
  if (hasValue(mode)) segs.push(String(mode));

  for (const k of segKeys) {
    if (segs.length >= maxSegs) break;
    if (k === field.key) break; // 保險：不納入自己
    const v = readValueByKey(EFFormData, k);
    if (hasValue(v)) segs.push(String(v));
  }

  return segs.join("!!");
};
